import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { SuprimentosService } from './../../../services/suprimentos/suprimentos.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { AuthenticationService, UsuarioService } from 'src/app/services';
import { IGetUsuarioQueryParams } from 'src/app/interfaces';
import { ETipo } from 'src/app/enums';
import { NovoSuprimentoFormProvider } from 'src/app/providers';

@Component({
  selector: 'app-novo-suprimento-c',
  templateUrl: './novo-suprimento-c.component.html',
  styleUrls: ['./novo-suprimento-c.component.scss']
})
export class NovoSuprimentoCComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  form: FormGroup;
  constructor(
    private novoSuprimentoFormProvider: NovoSuprimentoFormProvider,
    private authenticationService: AuthenticationService,
    private suprimentoService: SuprimentosService,
    private usuarioService: UsuarioService,
    private router: Router,
    private location: Location
  ) {}
  prosseguir() {
    const formularioCompleto = this.novoSuprimentoFormProvider.getForm();
    this.subscriptions$.add(
      this.suprimentoService
        .postSuprimento({
          ...formularioCompleto.get('primeiroPasso')?.value,
          ...(
            formularioCompleto.get('segundoPasso') as FormGroup
          )?.getRawValue(),
          ...formularioCompleto.get('terceiroPasso')?.value
        })
        .subscribe({
          next: ({ data: { codigo } }) => {
            this.router.navigate(['/novo-suprimento/abrir-chamado/4', codigo]);
            this.novoSuprimentoFormProvider.limparForm();
          }
        })
    );
  }
  obterUsuarioEquipamento() {
    const token = this.authenticationService.obterToken();
    const queryParams: IGetUsuarioQueryParams = {
      idUsuario: token.id,
      usuarioId: token.id
    };

    this.subscriptions$.add(
      this.usuarioService.getUsuario(queryParams).subscribe(
        ({
          data: {
            registros: [usuario]
          }
        }) => {
          if (!usuario) {
            return;
          }

          if (usuario.tipoUsuario === ETipo.INTERNO) {
            this.form.patchValue({
              nome: usuario.nome,
              email: usuario.email
            });
            return;
          }

          this.form.patchValue({
            nome: usuario.nome,
            email: usuario.email,
            celular: usuario.celular,
            telefone: usuario.telefone
          });
        }
      )
    );
  }
  ngOnInit() {
    const primeiroPassoInvalido = this.novoSuprimentoFormProvider
      .getForm()
      .get('segundoPasso')?.valid;
    if (!primeiroPassoInvalido) {
      this.location.back();
      return;
    }

    this.form = this.novoSuprimentoFormProvider
      .getForm()
      .get('terceiroPasso') as FormGroup;
    this.obterUsuarioEquipamento();
  }
  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
